/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-search': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data: '<g transform="translate(1 1)" _stroke="#6CA2CA" _fill="none" fill-rule="evenodd" stroke-linejoin="round"><path pid="0" d="M9.597 10.634L14.1 15.41l-4.502-4.776z" stroke-linecap="round"/><ellipse pid="1" cx="5.752" cy="6.063" rx="5.752" ry="6.063"/></g>'
  }
})
